<template>
    <!-- Tuile d'un moyen de paiement : la case (masquée) sélectionne le moyen, le montant s'édite ensuite -->
    <div
        v-if="!method.name.includes('Abonnement') && !method.name.includes('Cure') && !method.name.includes('cadeau')"
        class="ckp-method form-check form-block"
    >
        <slot name="checkbox"></slot>
        <label class="form-check-label" :for="'checkbox_' + method.name" :style="{ '--method-color': method.color || '#c3c9d2' }">
            <span class="ckp-method-name">{{ method.name }}</span>
            <span class="ckp-method-input"><slot name="input"></slot><span>€</span></span>
        </label>
    </div>
    <input v-else type="hidden" :name="'payments[' + method.name + ']'" v-model="method.value" />
</template>

<script>
export default {
    props: ['method', 'remainPrice'],
}
</script>
